import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

// styles
import './assets/css/vendor/normalize.css'
import './assets/css/scss/style.scss'


// filters
import filters from "./filters"

// vuex store
import store from './store';

// vue google maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.GOOGLE_MAPS_API,
    libraries: ['drawing','places'], //Place is for fuzzy search on Location search box
    },
  autobindAllEvents: true,
  installComponents: true,
})

import GmapCluster from 'vue2-google-maps/dist/components/cluster' // replace src with dist if you have Babel issues
Vue.component('GmapCluster', GmapCluster)

// localstorage 
import VueLocalStorage from 'vue-localstorage' //Used for authentication Tokens and Area IDs
Vue.use(VueLocalStorage, {
  name: 'ls',
  bind: true //created computed members from your variable declarations
})

// // logo for stripe checkout form
// import logo from '@/assets/images/company-logo.svg';
// // stripe integration - https://github.com/jofftiquez/vue-stripe-checkout
// import VueStripeCheckout from 'vue-stripe-checkout';
// const stripeOptions = {
//   key: process.env.STRIPE_PUB_KEY,
//   image: logo,
//   locale: 'auto',
//   currency: 'GBP',
//   panelLabel: 'Pay {{amount}}'
// }

// Vue.use(VueStripeCheckout, stripeOptions);

// copytoclipboard
import VueClipboard from 'vue-clipboard2' //Used for Copy Share URL button
Vue.use(VueClipboard);


// notifications
import Toasted from 'vue-toasted'; //Notifcations Popups
Vue.use(Toasted)

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created(){
  	let vm = this;
  	this.$store.dispatch('getLocalStoredAreas', vm);
    this.$store.dispatch('checkLoggedIn');
    // this.$store.dispatch('designData');
  }
})





// WEBPACK FOOTER //
// ./src/main.js